import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2457984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = { class: "chat-section" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, "用户列表", -1))
const _hoisted_6 = { class: "user-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "item-avatar" }
const _hoisted_9 = { class: "avatar-circle" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "item-info" }
const _hoisted_13 = { class: "item-top" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "item-time" }
const _hoisted_16 = { class: "item-preview" }
const _hoisted_17 = { class: "chat-window" }
const _hoisted_18 = { class: "chat-header" }
const _hoisted_19 = { class: "load-more-wrapper" }
const _hoisted_20 = {
  key: 1,
  class: "loading-history"
}
const _hoisted_21 = {
  key: 0,
  class: "time-separator"
}
const _hoisted_22 = {
  key: 1,
  class: "recalled-row"
}
const _hoisted_23 = ["onContextmenu"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "message-content-wrapper" }
const _hoisted_28 = { class: "message-info" }
const _hoisted_29 = {
  key: 0,
  class: "role-tag"
}
const _hoisted_30 = { class: "message-bubble" }
const _hoisted_31 = {
  key: 0,
  class: "image-content"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "input-area-wrapper" }
const _hoisted_34 = { class: "input-box" }
const _hoisted_35 = { class: "toolbar" }
const _hoisted_36 = { class: "emoji-picker" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "action-bar" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("发送")
const _hoisted_42 = {
  key: 1,
  class: "no-permission"
}
const _hoisted_43 = {
  key: 1,
  class: "offline-mask"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FdLoading = _resolveComponent("FdLoading")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_SmileOutlined = _resolveComponent("SmileOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_PictureOutlined = _resolveComponent("PictureOutlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["chat-card", { 'has-sidebar': _ctx.permissionType === 2 }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.initLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_FdLoading)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.permissionType !== 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["chat-wrapper", { 'teacher-mode': _ctx.permissionType === 2 }])
                  }, [
                    (_ctx.permissionType === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _hoisted_5,
                          _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.username || item.suid || item.easemob_name,
                                class: _normalizeClass(['user-list-item', _ctx.isActiveChat && _ctx.isActiveChat(item) ? 'active' : '']),
                                onClick: ($event: any) => (_ctx.selectChat(item))
                              }, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_a_badge, {
                                    count: (item.unreadCount || 0) > 0 ? item.unreadCount : 0,
                                    overflowCount: 99
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, [
                                        (item.avatar)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: item.avatar
                                            }, null, 8, _hoisted_10))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.nickname ? item.nickname.charAt(0) : item.username.charAt(0)), 1))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["count"])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("span", {
                                      class: "item-name",
                                      title: item.nickname || item.username
                                    }, _toDisplayString(item.nickname || item.username), 9, _hoisted_14),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatListTime(item.time)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.lastMessage), 1)
                                ])
                              ], 10, _hoisted_7))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentUserName), 1),
                        (_ctx.initLoading)
                          ? (_openBlock(), _createBlock(_component_a_spin, {
                              key: 0,
                              size: "small"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "message-list",
                        ref: "messageListRef",
                        onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.hasMoreHistory && !_ctx.isLoadingHistory && _ctx.messages.length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "load-more-text",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLoadMore && _ctx.handleLoadMore(...args)))
                              }, " 加载更多 "))
                            : _createCommentVNode("", true),
                          (_ctx.isLoadingHistory)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createVNode(_component_FdLoading)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: msg.id || index,
                            class: "message-row"
                          }, [
                            (_ctx.shouldShowTime(index))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.formatTime(msg.time)), 1))
                              : _createCommentVNode("", true),
                            (msg.isRecalled)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(msg.isMe ? '你' : '对方') + "撤回了一条消息 ", 1))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: _normalizeClass(['message-item', msg.isMe ? 'my-message' : 'other-message']),
                                  onContextmenu: _withModifiers(($event: any) => (_ctx.handleContextMenu($event, msg)), ["prevent"])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["avatar", { 'teacher-avatar': _ctx.isTeacherMessage(msg) }])
                                  }, [
                                    (msg.avatar)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: msg.avatar
                                        }, null, 8, _hoisted_24))
                                      : (msg.from.length > 2)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(msg.from.slice(-2)), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(msg.from), 1))
                                  ], 2),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["name", { 'teacher-name': (_ctx.permissionType === 2 && msg.isMe) || (_ctx.permissionType === 1 && !msg.isMe) }])
                                      }, _toDisplayString(_ctx.getDisplayName(msg)), 3),
                                      ((_ctx.permissionType === 2 && msg.isMe) || (_ctx.permissionType === 1 && !msg.isMe))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "老师"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      (msg.type === 'img' && msg.url)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createVNode(_component_a_image, {
                                              src: msg.url,
                                              preview: true
                                            }, null, 8, ["src"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["text", { 'emoji-text': _ctx.useEmojiImage }]),
                                            innerHTML: _ctx.parseEmoji(msg.msg)
                                          }, null, 10, _hoisted_32))
                                    ])
                                  ])
                                ], 42, _hoisted_23))
                          ]))
                        }), 128))
                      ], 544),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            (_ctx.supportsEmoji)
                              ? (_openBlock(), _createBlock(_component_a_popover, {
                                  key: 0,
                                  visible: _ctx.showEmoji,
                                  "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEmoji) = $event)),
                                  trigger: "click",
                                  placement: "topLeft",
                                  overlayClassName: "emoji-popover"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_36, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojiList, (emoji) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: emoji,
                                          class: "emoji-item",
                                          onClick: ($event: any) => (_ctx.handleEmojiClick(emoji))
                                        }, [
                                          (_ctx.useEmojiImage)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: _ctx.emojiToImage(emoji),
                                                alt: emoji,
                                                class: "emoji-picker-img"
                                              }, null, 8, _hoisted_38))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(emoji), 1))
                                        ], 8, _hoisted_37))
                                      }), 128))
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_SmileOutlined, { class: "toolbar-icon" })
                                  ]),
                                  _: 1
                                }, 8, ["visible"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_PictureOutlined, {
                              class: "toolbar-icon",
                              onClick: _ctx.handleImageUpload
                            }, null, 8, ["onClick"]),
                            _createElementVNode("input", {
                              type: "file",
                              ref: "fileInput",
                              style: {"display":"none"},
                              accept: "image/*",
                              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                            }, null, 544)
                          ]),
                          _createVNode(_component_a_textarea, {
                            class: "chat-textarea",
                            ref: "textareaRef",
                            value: _ctx.inputText,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputText) = $event)),
                            rows: 3,
                            onPressEnter: _ctx.handleSend,
                            placeholder: "请输入消息...",
                            disabled: !_ctx.isConnected,
                            bordered: false
                          }, null, 8, ["value", "onPressEnter", "disabled"]),
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              class: "send-btn",
                              onClick: _ctx.handleSend,
                              loading: _ctx.sending
                            }, {
                              default: _withCtx(() => [
                                _hoisted_41
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading"])
                          ])
                        ])
                      ])
                    ])
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createVNode(_component_a_result, { "sub-title": "不好意思，您没有权限访问这个聊天。" })
                  ]))
            ], 64))
      ])
    ], 2),
    (_ctx.contextMenu.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "context-menu",
          style: _normalizeStyle({ top: _ctx.contextMenu.y + 'px', left: _ctx.contextMenu.x + 'px' }),
          ref: "contextMenuRef"
        }, [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerRecall && _ctx.triggerRecall(...args)))
          }, "撤回消息")
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.isKickedOffline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43))
      : _createCommentVNode("", true)
  ]))
}